import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {track} from "src/shared/utils/TrackingUtils";

export function FlowsManager() {
  /* Import variables from props. */
  const navigate = useNavigate();
  const param = useParams();

  /* Immediately redirect-utils. */
  useEffect(
    () => {
      const { flowType, id } = param;

      // If the flowType is pdj (Program Direct Join), we will navigate to the join immediately.
      if (flowType === 'pdj') {
        // Add a tracking point.
        if (id)
          track('WebApp_FlowsManager', [id])
        else
          track('WebApp_FlowsManager');

        // Navigate while preserving the parameters.
        navigate(`/programs/${id}/join${window.location.search}`);
        return;
      }

      navigate('/app');
    },
    []
  )

  return <></>;
}

export default FlowsManager;